import { StudioLayout } from "../pages/StreamLayoutPage/StreamLayoutPage";

/**
 * Преобразует строку макета в объект JSON
 * @param rawLayout - исходная строка макета
 * @returns распарсенный объект макета
 */
export const parseStudioParams = (rawLayout: string | null): StudioLayout | undefined => {
  if (!rawLayout) {
    return;
  }

  try {
    let layoutToProcess = rawLayout;

    if (layoutToProcess.includes('\\\"')) {
      layoutToProcess = layoutToProcess.replace(/\\"/g, '"');
    }

    const decodedLayout = decodeURIComponent(layoutToProcess);

    let jsonString = decodedLayout;
    if (jsonString.startsWith('"') && jsonString.endsWith('"')) {
      jsonString = jsonString.slice(1, -1);
      jsonString = jsonString.replace(/\\"/g, '"');
    }

    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Error parsing studio params:', error);
    return;
  }
};